/**
 * Why an async AI job failed (TMMAPI-0152 ask 8 and its addendum): envelope analyses and meeting
 * summaries carry `failureReason` on a FAILED job, to every reader, and `firstPurchaseRequired` only
 * to the person whose wallet was refused. Absent on jobs that failed before 0152.
 */
import type { EnvelopeAnalysisResponse as WireAnalysis } from './generated';

export type AiJobFailureReason = NonNullable<WireAnalysis['failureReason']>;

export const AI_JOB_FAILURE_REASONS: readonly AiJobFailureReason[] = [
  'WALLET_EMPTY',
  'PERSON_CAP',
  'NO_PRICE',
  'SUSPENDED',
  'AI_DEBT',
  'BUSY',
  'SUBSCRIPTION_INACTIVE',
  'DAILY_CAP',
  'AI_DISABLED',
  'HOLD_EXPIRED',
  'PROVIDER_ERROR',
  'RECORD_FAILED',
];

/** The served reason, or `null` (absent, or a value this build doesn't know). */
export function normalizeAiJobFailureReason(
  value: string | null | undefined,
): AiJobFailureReason | null {
  return AI_JOB_FAILURE_REASONS.find((reason) => reason === value) ?? null;
}
